import { render, staticRenderFns } from "./Xiezhensc.vue?vue&type=template&id=49b07b78&scoped=true&"
import script from "../jscript/Xiezhensc.js?vue&type=script&lang=js&"
export * from "../jscript/Xiezhensc.js?vue&type=script&lang=js&"
import style0 from "./Xiezhensc.vue?vue&type=style&index=0&id=49b07b78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b07b78",
  null
  
)

export default component.exports